export default {
    'search-by': 'Search by',
    'search-type': {
        all: 'all',
        city: 'city',
        'medical-rep': 'Medical rep',
    }
}